export enum OrgUnitType {
  DEPARTMENT = 'DEPARTMENT',
  MAIN_DEPARTMENT = 'MAIN_DEPARTMENT'
}
